import React from "react";

import {
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import { Link } from "react-router-dom";

import { formatCurrency } from "@ds-developer/frontend";

import ArrearsSkeleton from "../Skeleton";

const useStyles = makeStyles(theme => ({
  noItems: {
    flexGrow: 1,
    margin: theme.spacing(1.5),
    textAlign: "center",
    color: theme.palette.grey[500],
  },
  rowText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: theme.spacing(2),
    fontSize: "0.75rem",
    fontWeight: theme.typography.fontWeightBold,
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold,
  },
  footerIcon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  button: {
    color: theme.palette.secondary.main,
  },
}));

type ArrearsCardProps = {
  arrears: number;
  isLoading?: boolean;
};

const ArrearsCard: React.FC<ArrearsCardProps> = ({
  isLoading = false,
  arrears = 0,
}) => {
  const classes = useStyles();

  return (
    <Card>
      <CardHeader
        titleTypographyProps={{ component: "h3", variant: "h3" }}
        title="Overview"
      />
      <Divider />
      {isLoading ? (
        <ArrearsSkeleton />
      ) : (
        <Box flexGrow={1} className={classes.rowText}>
          <Typography variant="body2">Amount owed</Typography>
          <Typography variant="body2">
            {formatCurrency(arrears, false, {
              displayDecimalValue: true,
            })}
          </Typography>
        </Box>
      )}
      <Divider />
      <Box flexGrow={1} className={classes.footer}>
        <Typography variant="body2">Balance breakdown</Typography>
        <Button
          endIcon={<ChevronRight width={20} />}
          to="/accounts"
          component={Link}
          className={classes.button}
          data-test="see-all-arrears-link"
        >
          View
        </Button>
      </Box>
    </Card>
  );
};

export default ArrearsCard;
